// utils/getFaceData.js
export const getVisitorFaceData = (visitorId) => {
  if (!visitorId) return null;

  // Get all keys in localStorage
  const matchingKeys = Object.keys(localStorage).filter((key) =>
    key.includes(visitorId)
  );

  // Find the first key with valid data
  const faceKey = matchingKeys.find((key) => localStorage.getItem(key));

  if (!faceKey) return null;

  try {
    // Parse JSON if stored as stringified object, else return as-is
    const data = localStorage.getItem(faceKey);
    return JSON.parse(data);
  } catch (error) {
    // If parsing fails, return raw string
    return localStorage.getItem(faceKey);
  }
};
